import React, { useState } from "react";
import {
    MDBCol,
    MDBTable,
    MDBTableHead,
    MDBTableBody,
    MDBPagination,
    MDBPaginationItem,
    MDBPaginationLink,
    MDBBadge,
} from "mdb-react-ui-kit";
import { useCart } from "./CartContext";
import { useNavigate } from "react-router";

export default function MembershipTable({ plans, handlePlandetails, currentPage, setCurrentPage }) {

    const rowsPerPage = 5;
    const { addToCart, isItemInCart, removeFromCart } = useCart();
    const navigate = useNavigate();
    // total rows = number of plans
    const totalRows = plans.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);

    // slice plans based on page
    const currentPlans = plans.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    return (
        <div className="newtable_content bg-white">
            <div className="whatsapp_table mb-2">
                <MDBTable responsive className="newtable-view m-0">
                    <MDBTableHead>
                        <tr>
                            <th scope="col">Membership Name</th>
                            <th scope="col">Duration</th>
                            <th scope="col">Sessions</th>
                            <th scope="col">Price</th>
                            <th scope="col">Actions</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                        {currentPlans.map((plan, index) => (
                            <tr key={index}>
                                <td className="text-primary">{plan?.displayName || plan?.name}

                                    <MDBBadge light className="ms-2" color={plan.type === "plan" ? "primary" : "success"}>
                                        {plan.type === "plan" ? "Plan" : "Addon"}
                                    </MDBBadge>
                                </td>
                                <td>{plan.duration}</td>
                                <td>
                                    {plan.sessioncheck
                                        ? `${plan.sessionvalue} sessions`
                                        : "--"}
                                </td>
                                <td>{plan.price}/-</td>
                                <td>
                                    <div>
                                        <span className='' title="View Details" onClick={() => handlePlandetails(plan)} ><i class="fa-solid fa-eye"></i></span>
                                        <span className={`mx-1 ${!isItemInCart(plan?._id) ? "text-primary" : "text-danger"} `} title="Add to cart" onClick={!isItemInCart(plan?._id) ? () => addToCart(plan) : () => removeFromCart(plan?._id)}> {!isItemInCart(plan?._id) ? <i className="fas fa-shopping-cart"></i> : <i className="fas fa-close"></i>}</span>
                                        <span className='' title="Buy Now" onClick={() => navigate('/memberbilling', { state: { cartItems: [plan] } })}>  <i className="fas fa-credit-card menu-icon m-0"></i>  </span>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        {currentPlans.length === 0 && (
                            <tr>
                                <td colSpan="4" className="text-center text-muted py-3">
                                    No Memberships available
                                </td>
                            </tr>
                        )}
                    </MDBTableBody>
                </MDBTable>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
                <nav className="d-flex justify-content-end mb-1">
                    <MDBPagination className="mb-0 pagenation-view">
                        {/* Prev */}
                        <MDBPaginationItem
                            className="pagenation-link"
                            disabled={currentPage === 1}
                        >
                            <MDBPaginationLink
                                className="pagenation-btn"
                                onClick={() => setCurrentPage((p) => p - 1)}
                            >
                                <i className="fa-solid fa-angles-left me-1"></i> Previous
                            </MDBPaginationLink>
                        </MDBPaginationItem>

                        {/* Pages */}
                        {[...Array(totalPages)].map((_, i) => (
                            <MDBPaginationItem
                                className="pagenation-link"
                                key={i}
                                active={i + 1 === currentPage}
                            >
                                <MDBPaginationLink
                                    className="cursor-pointer"
                                    onClick={() => setCurrentPage(i + 1)}
                                >
                                    {i + 1}
                                </MDBPaginationLink>
                            </MDBPaginationItem>
                        ))}

                        {/* Next */}
                        <MDBPaginationItem
                            className="pagenation-link"
                            disabled={currentPage === totalPages}
                        >
                            <MDBPaginationLink
                                className="pagenation-btn"
                                onClick={() => setCurrentPage((p) => p + 1)}
                            >
                                Next <i className="fa-solid fa-angles-right ms-1"></i>
                            </MDBPaginationLink>
                        </MDBPaginationItem>
                    </MDBPagination>
                </nav>
            )}
        </div>
    );
}
